'use client'

import { useEffect, useRef, useState } from 'react'
import styles from './ua.module.scss'
import Autolinker from 'autolinker';
import CollapsedText from '@/components/collapsed/CollapsedText';
import Accordian from '@/components/accordian/Accordian';
import Icon from '@/components/icon/Icon';
import Pill from '@/components/pills/Pill';
import Image from 'next/image';
import useEventListener from '@/components/plugins/EventListener';
import Button from '@/components/button/Button';

const highlightDisplayOrders = [
  'Great for Family',
  'Great For Work',
  'Under 20K',
  'Low Miles',
  'New',
  'Great Deal',
  'Popular',
  'Hot',
]

const specsDisplayOrders = [
  'Exterior Color',
  'Interior Color',
  'Engine',
  'Transmission',
  'Drivetrain',
  'Fuel Type',
  'Fuel Efficiency',
  'Seats',
  'Doors',
]

export default function VehicleFeatures(props) {
  
  const vehicle = props.vehicle

  const linkedText = Autolinker.link(vehicle.detail?.description);
  const [highlights,setHighlights] = useState([])
  const [specs,setSpecs] = useState([])
  const [basic,setBasic] = useState()
  const [details,setDetails] = useState()
  
  const [showFeedDetails, setShowFeedDetails] = useState(false)
  
  const featureSection = useRef()

  // specs.push({ header: 'Exterior Color', value: vehicle.exterior_color, displayOrder: specsDisplayOrders.indexOf('Exterior Color') })
  // specs.push({ header: 'Interior Color', value: vehicle.interior_color, displayOrder: specsDisplayOrders.indexOf('Exterior Color') })
  // // if (vehicle.specs?.engine_description) {
  // //   specs.push({ header: 'Engine', value: vehicle.specs?.engine_description })
  // // }
  // // if (vehicle.specs?.transmission) {
  // //   specs.push({ header: 'Transmission', value: vehicle.specs?.transmission })
  // // }
  // if (vehicle.specs?.fuel_type) {
  //   specs.push({ header: 'Fuel Type', value: vehicle.specs?.fuel_type, displayOrder: specsDisplayOrders.indexOf('Fuel Type') })
  // }
  // if (specs.length < 4 && vehicle.specs?.drive_train) {
  //   specs.push({ header: 'Drivetrain', value: vehicle.specs?.drive_train, displayOrder: specsDisplayOrders.indexOf('Drivetrain') })
  // }
  // // if (specs.length < 4 && vehicle.specs?.body_style) {
  // //   specs.push({ header: 'Body Style', value: BODY_STYLES[vehicle.specs?.body_style]?.label })
  // // }

  useEventListener("vehicle_features_loaded", event => {
    const details = event.detail
    setDetails(details.details)
    setBasic(details.basic)
    setHighlights(details.highlights)
    setSpecs(details.specs)
    setShowFeedDetails(details.showFeedDetails)
  })

  const buildInfo = (items, large) => {
    return <div className={ styles.specs }>
      { items.map((item, index) => (
      <div key={index}>
        {/* <div>&middot;</div> */}
        { Array.isArray(item) && (item[0] + "").toLowerCase() != (item[4] + "").toLowerCase() ?
        <div>
          <div className='flex-column'>
            <div className='text-xs text-primary'>{ item[0] }</div>
            <div className={'' + (large ? ' text-md text-bold' : '')}>{ item[1] }</div>
          </div>
        </div>
        :
        <div className={'text-sm' + (large ? ' text-md text-bold' : '')}>{ item[0] }</div>
        }
      </div>
      ))}
    </div>
  }

  useEffect(() => {
  }, [])

  return <>
    <section>
      <div className={styles.hilit}>
        <div className={ styles.hilitd}>        
          { vehicle.condition != 1 && vehicle.history?.report_url &&
          <div className="flex-col flex-stretch">
            <Button theme={["none"]} label={ 'Show me the Carfax' } href={ vehicle.history?.report_url } target="_blank">
              <div className="flex-column flex-align-middle flex-align-center">
                <div className="flex-col">
                  <Image src={ process.env.NEXT_PUBLIC_CDN + "/images/partner/carfax.png"} height="24" width="124" alt="Carfax Report"></Image>
                </div>
                <div className="flex-col" style={{width:'124px'}}>
                  <Pill theme={['primary-faint','full']}>Free Report &gt;</Pill>
                </div>
              </div>
            </Button>
          </div>
          }
          { highlights.map((item,index) => (
          <div key={index} className="flex-col flex-stretch">
            <div className="flex-column flex-align-middle flex-align-center">
              <div className={ 'flex-col ' + styles.ft_ico }><Icon {...props} name={ item.icon }></Icon></div>
              <div className="flex-col text-sm">{ item.label }</div>
            </div>
          </div>
          ))}
        </div>
      </div>
    </section>
    <section>
      <h2 className={ styles.h + ' ' + styles.h2 }>Features</h2>
    </section>
    <section>
        { buildInfo(specs, true) }
    </section>
    { basic &&
    <section>
      { buildInfo(basic) }
    </section>
    }
    { details &&
    <CollapsedText {...props} ref={featureSection} expandLabel={'Show More Features'} collapseLabel={'Show Less Features'} fullCollapsed={true}>
      <section>
        <Accordian {...props} data={details}></Accordian>
      </section>
      <section>
        <div dangerouslySetInnerHTML={{__html: linkedText }}></div>
      </section>
    </CollapsedText>
    }
    { showFeedDetails &&
    <CollapsedText {...props} ref={featureSection} expandLabel={'Show More Features'} collapseLabel={'Show Less Features'}>
      <section>
        <div className={ styles.specs }>
        { vehicle.detail?.features?.map((opt,index) => (
        <div key={index}>
          <div className='text-sm'>{ opt }</div>
        </div>
        ))}
        </div>
      </section>
      <section>
        <div dangerouslySetInnerHTML={{__html: linkedText }}></div>
      </section>
    </CollapsedText>
    }
  </>
}
